function endTrial(forceEndTrial, skipFeedback, skipLogic)
{
  $(document).trigger(window.events.endTrial);
  recordKeys = 0;
  recordRTkeys = 0;
  RTkeys_trial = '';
  // multiple key responses
  window.keyPressedCounter = null;
  window.trialKeysPressedCounter = 0;
  window.keysTrial = null;
  // end multiple key responses
  clickResponseValue = '';
  window.currentResponseText = "na";

  if (listStimType[trialRow]==3 || listStimType[trialRow]==4) //sounds and videos
  {
    try {
      stimContainers[1].pause();
    } catch (error) {
      console.error('media was not loaded');
    }
  }

  // for audio container
  if(!window.loopAudio || window.audioStopCountdown === 0) {
    window.stopBackgroundAudio();
  }

  if (window.audioStopCountdown >= 0) {
    window.audioStopCountdown--;
  }
  cleanMobileTricks();
  cleanRandomizedStimClick();
  clearMultipleClicksSelection();
  clearDroppables();
  clearSliders();
  clearMic();
  resetStimCssOptions();

  window.clearSortable();
  $('#saveDragButton').remove();

  if(isLongWordTrial(window.trialRow)){
    cleanLongWords(trialRow);
  }

  if(window.columnForTrial('responseType', window.trialRow)){
    window.hideAndClearResponseBoxes();
  }

  if(listTrialColorOptions[window.trialRow]){
    window.clearColorOptions(listTrialColorOptions[window.trialRow]);
  }
  
  if (skipFeedback || (!window.isFeedbackSameScreen() && (!window.shouldWaitResponseWindow() || forceEndTrial))) {
    hideAll();
  }
  else{
    disableResponses();
  }

  if (!skipFeedback && (feedbackScreen == 0 && ((listArrays[allColumns.indexOf('feedbackCorrect')][trialRow]!="na" && ((listArrays[allColumns.indexOf('type')][trialRow]=="test" && correct[correct.length-1]=="1") || (listArrays[allColumns.indexOf('type')][trialRow]=="practice" && correctPractice[correctPractice.length-1]=="1"))) || (listArrays[allColumns.indexOf('feedbackIncorrect')][trialRow]!="na" && ((listArrays[allColumns.indexOf('type')][trialRow]=="test" && correct[correct.length-1]=="0") || (listArrays[allColumns.indexOf('type')][trialRow]=="practice" && correctPractice[correctPractice.length-1]=="0"))))))
    {
      feedback();
    }
  else if (!skipFeedback && (feedbackScreen == 0 && columnForTrial('feedback',trialRow)!="na" && (columnForTrial('type',trialRow)=="test" || columnForTrial('type',trialRow)=="practice")))
    {
      feedback();
    }
  else
    {
      if (!window.shouldWaitResponseWindow() || forceEndTrial) {
        window.resetCursor();
        main(undefined, undefined, skipLogic);
      }
    }
}